import { createSelector } from 'reselect';
import IpcTrayUsageColumns from '../../containers/IpcTrayUsageColumns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  .reporting.TRAY_USAGE_940.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.TRAY_USAGE_940.isLoading;

export const getData =
  ReportDefinitions.TRAY_USAGE_940.getDataFunction();

export const getColumns =
  createSelector(getData, IpcTrayUsageColumns);
